export enum ModalDirection {
    Up = "up",
    Down = "down",
    Left = "left",
    Right = "right"
}